import { useResponsiveDrawerColumns } from 'hooks/useResponsiveDrawerColumns';
import { getText } from 'i18n/intl';
import {
  looseUuidPatternValidationRule,
  requiredValidationRule,
} from 'utils/validations';
import type {
  OutlookConfiguration,
  OutlookConfigurationResponse,
} from '@timeedit/calendar-integration-api-contract';
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';
import { Form, type FormInstance } from '@timeedit/ui-components/antd';

export const intlPrefix = 'integration.calendar.configuration';

export type CreateOutlookConfiguration = Omit<OutlookConfiguration, 'id'>;

type Props = {
  config: OutlookConfigurationResponse;
  form: FormInstance<OutlookConfiguration>;
  onValuesChange: (
    changedValues: Partial<OutlookConfiguration>,
    values: OutlookConfiguration
  ) => void;
};

const MS365ConfigurationDetails = ({ config, form, onValuesChange }: Props) => {
  const { formLayout } = useResponsiveDrawerColumns();

  return (
    <TEDrawerSection label={getText(`${intlPrefix}.title`)}>
      <Form
        {...formLayout}
        labelAlign="left"
        size="middle"
        form={form}
        initialValues={config ?? {}}
        onValuesChange={onValuesChange}
      >
        <div
          style={{
            display: 'flex',
            gap: '8px',
            flexDirection: 'column',
            width: '33%',
            minWidth: '432px',
          }}
        >
          <Form.Item hidden name="id" />
          <Form.Item
            label={getText(`${intlPrefix}.form.name.label`)}
            name="name"
            rules={[requiredValidationRule]}
            tooltip={getText(`${intlPrefix}.form.name.description`)}
          >
            <TEInput.Input />
          </Form.Item>
          <Form.Item
            label={getText(`${intlPrefix}.form.tenant_id.label`)}
            name="tenantId"
            rules={[requiredValidationRule, looseUuidPatternValidationRule]}
            tooltip={getText(`${intlPrefix}.form.tenant_id.description`)}
          >
            <TEInput.Input />
          </Form.Item>
          <Form.Item
            label={getText(`${intlPrefix}.form.client_id.label`)}
            name="clientId"
            rules={[requiredValidationRule, looseUuidPatternValidationRule]}
            tooltip={getText(`${intlPrefix}.form.client_id.description`)}
          >
            <TEInput.Input />
          </Form.Item>
          <Form.Item
            label={getText(`${intlPrefix}.form.client_secret.label`)}
            name="clientSecret"
            tooltip={getText(`${intlPrefix}.form.client_secret.description`)}
          >
            <TEInput.Input type="password" />
          </Form.Item>
        </div>
      </Form>
    </TEDrawerSection>
  );
};

export default MS365ConfigurationDetails;
